<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <span class="breadcrumb-link">Help</span>
    <span class="breadcrumb-sep"></span>
    <span class="breadcrumb-current">Macronize - Timeline Calculator</span>
  </div>
</div>

<main class="page-content">
  <div class="notice" role="note">
    <svg class="notice-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
    </svg>
    <span>All dates use working business days only. Weekends are excluded. If a calculated date falls on a weekend, it moves to the following Monday. Public holiday exclusion is out of scope.</span>
  </div>

  <section class="calculator" aria-labelledby="calculator-title">

    <div class="calculator-card">
      <header class="calculator-header">
        <h4 id="calculator-title">Macronize - Timeline Calculator</h4>
      </header>

      <form [formGroup]="form" (ngSubmit)="calculate()">
        <div class="selection-row" style="margin-top: 16px;">
          <label class="review-select">
            <span>Review type and location <b>*</b></span>
            <select formControlName="selectedReview" (change)="onReviewChange()">
              <option value="" disabled hidden>Select review type and location</option>
              @for (group of reviewOptionGroups; track group.label) {
                <option disabled class="opt-group-header">{{ group.label }}</option>
                @for (option of group.options; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              }
            </select>
          </label>
          <button type="button" class="secondary-button" (click)="clear()">
            Clear / Reset
          </button>
          <button type="submit" class="primary-button" [disabled]="form.invalid">Calculate</button>
        </div>

        @if (showDateFields) {
          <section class="date-section" aria-label="Review dates">
            <div class="date-fields">
              <label>
                <span>{{ startDateLabel }} <b>*</b></span>
                <div class="date-picker-field">
                  <input type="text" class="date-display" [value]="formatPickerDate(form.get('fieldworkStartDate')?.value)"
                    placeholder="dd-mmm-yyyy" readonly (click)="openDatePicker(startDatePicker)" />
                  <input #startDatePicker type="date" class="native-date-picker" formControlName="fieldworkStartDate" aria-hidden="true" tabindex="-1" />
                  <button type="button" class="date-picker-button" aria-label="Open start date calendar"
                    (click)="openDatePicker(startDatePicker)">
                    <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
                  </button>
                </div>
              </label>
              <div class="end-date-wrapper">
                <label>
                  <span>{{ endDateLabel }} <b>*</b></span>
                  <div class="date-picker-field">
                    <input type="text" class="date-display" [value]="formatPickerDate(form.get('fieldworkEndDate')?.value)"
                      placeholder="dd-mmm-yyyy" readonly (click)="openDatePicker(endDatePicker)"
                      [attr.aria-invalid]="hasInvalidDateRange" aria-describedby="date-range-error" />
                    <input #endDatePicker type="date" class="native-date-picker" formControlName="fieldworkEndDate" aria-hidden="true" tabindex="-1" />
                    <button type="button" class="date-picker-button" aria-label="Open end date calendar"
                      (click)="openDatePicker(endDatePicker)">
                      <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
                    </button>
                  </div>
                </label>
                @if (hasInvalidDateRange) {
                  <p id="date-range-error" class="validation-error">{{ dateRangeError }}</p>
                }
              </div>
            </div>
          </section>
        }

        @if (results && selectedOption) {
          <section class="results-panel" aria-live="polite">
            <div class="results-title calculated-title">
              <h2>{{ selectedOption.title }}</h2>
              <span>Calculated on {{ formatDate(calculatedOn!) }}</span>
            </div>
            <div class="results-table" role="table" aria-label="Calculated review activity dates">
              <div class="table-row table-header" role="row">
                <span role="columnheader">Activities</span>
                <span role="columnheader">Calculated Date</span>
              </div>
              @for (result of results; track result.activity) {
                <div class="table-row" role="row">
                  <span role="cell">
                    {{ result.activity }}
                    @if (result.entered) { <small>entered</small> }
                  </span>
                  <strong role="cell" [class.entered-date]="result.entered">{{ formatDate(result.date) }}</strong>
                </div>
              }
            </div>
          </section>

          <div class="export-actions">
            <button type="button" class="export-button" (click)="exportToXlsx()">
              Export to Excel (XLSX)
            </button>
          </div>
        }
      </form>
    </div>

  </section>
</main>